import React from 'react';
import { portfolioData } from '../data/mock';

const About = () => {
  const { personal, stats } = portfolioData;

  return (
    <section id="about" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="section-label">Introduction</span>
          <h2 className="section-title">
            About <span className="text-accent">Me</span>
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16 max-w-4xl mx-auto">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-8 rounded-2xl border transition-all"
              style={{
                background: 'var(--bg-card)',
                borderColor: 'var(--border)'
              }}
            >
              <div className="text-5xl font-bold mb-2" style={{ color: 'var(--accent)' }}>
                {stat.value}
              </div>
              <div className="text-sm" style={{
                color: 'var(--text-muted)',
                fontFamily: 'JetBrains Mono, monospace'
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Bio */}
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <p className="text-xl md:text-2xl leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            {personal.bio}
          </p>
          <div className="flex items-center justify-center gap-3 pt-4">
            <div className="h-px w-16" style={{ background: 'var(--accent)' }}></div>
            <span style={{
              color: 'var(--text-muted)',
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '1rem'
            }}>
              {personal.location}
            </span>
            <div className="h-px w-16" style={{ background: 'var(--accent)' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
